/**
 * Stable CSS class names for E2E — Customer card paper (header + phone/email modals).
 */
export const CCP = {
    card: 'customer-card-paper',
    header: 'customer-card-paper__header',
    fieldChipStatus: 'customer-card-paper-field--status-chip',
    identityBlock: 'customer-card-paper__identity-block',
    customerIdRow: 'customer-card-paper__customer-id-row',
    inputIconButtonCopyCustomerId: 'customer-card-paper-input--icon-button-copy-customer-id',
    divider: 'customer-card-paper__divider',
    phoneRow: 'customer-card-paper__phone-row',
    inputIconButtonCopyPhone: 'customer-card-paper-input--icon-button-copy-phone',
    inputIconButtonEditPhone: 'customer-card-paper-input--icon-button-edit-phone',
    inputIconButtonRemovePhone: 'customer-card-paper-input--icon-button-remove-phone',
    emailRow: 'customer-card-paper__email-row',
    inputIconButtonCopyEmail: 'customer-card-paper-input--icon-button-copy-email',

    modalPhone: 'customer-card-paper-modal-phone',
    modalPhoneContent: 'customer-card-paper-modal-phone__content',
    modalPhoneTitle: 'customer-card-paper-modal-phone__title',
    inputTextfieldPhone: 'customer-card-paper-input--textfield-phone',
    modalPhoneLoading: 'customer-card-paper-modal-phone__loading',
    modalPhoneActions: 'customer-card-paper-modal-phone__actions',
    inputButtonPhoneUpdate: 'customer-card-paper-input--button-phone-update',
    inputButtonPhoneCancel: 'customer-card-paper-input--button-phone-cancel',

    modalOtp: 'customer-card-paper-modal-otp',
    modalOtpContent: 'customer-card-paper-modal-otp__content',
    inputIconButtonOtpClose: 'customer-card-paper-input--icon-button-otp-close',
    otpCountdownRing: 'customer-card-paper-modal-otp__countdown-ring',
    otpTitle: 'customer-card-paper-modal-otp__title',
    otpSubtitle: 'customer-card-paper-modal-otp__subtitle',
    modalOtpLoading: 'customer-card-paper-modal-otp__loading',
    otpInputsRow: 'customer-card-paper-modal-otp__inputs-row',
    inputTextfieldOtpDigit: 'customer-card-paper-input--textfield-otp-digit',
    otpResendSection: 'customer-card-paper-modal-otp__resend-section',
    inputButtonResendCode: 'customer-card-paper-input--button-resend-code',

    modalRemovePhoneOtp: 'customer-card-paper-modal-remove-phone-otp',
    modalRemovePhoneOtpContent: 'customer-card-paper-modal-remove-phone-otp__content',
    inputIconButtonRemovePhoneOtpClose: 'customer-card-paper-input--icon-button-remove-phone-otp-close',
    removePhoneOtpCountdownRing: 'customer-card-paper-modal-remove-phone-otp__countdown-ring',
    removePhoneOtpTitle: 'customer-card-paper-modal-remove-phone-otp__title',
    removePhoneOtpSubtitle: 'customer-card-paper-modal-remove-phone-otp__subtitle',
    modalRemovePhoneOtpLoading: 'customer-card-paper-modal-remove-phone-otp__loading',
    removePhoneOtpInputsRow: 'customer-card-paper-modal-remove-phone-otp__inputs-row',
    inputTextfieldRemovePhoneOtpDigit: 'customer-card-paper-input--textfield-remove-phone-otp-digit',
    removePhoneOtpResendSection: 'customer-card-paper-modal-remove-phone-otp__resend-section',
    inputButtonRemovePhoneResendCode: 'customer-card-paper-input--button-remove-phone-resend-code',
    removePhoneOtpActions: 'customer-card-paper-modal-remove-phone-otp__actions',
    inputButtonRemovePhoneOtpComplete: 'customer-card-paper-input--button-remove-phone-otp-complete',
} as const;

export const ccpCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
